import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Box } from '@mui/material';
import { IconElement } from 'console/shared/components/indicators/wifi/icon';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { getConnectionIconsDevice, getOnlineColor, } from 'console/shared/components/indicators/gsm/utils/selectors';
export const WiFiIcon = memo(function WiFiIcon(props) {
    const { open, device_id, fontSize, ...rest } = props;
    const icon_type = usePartialAppSelector(getConnectionIconsDevice, device_id)?.wifi;
    const color = usePartialAppSelector(getOnlineColor, device_id);
    if (!icon_type) {
        return null;
    }
    return (_jsx(Box, { display: "flex", position: "relative", fontSize: fontSize, onClick: open, children: _jsx(IconElement, { icon_type: icon_type, color: color, ...rest }) }));
});
